
class ChartOptions {
    private themeColours: string[] = ['#dd750f', '#B15903', '#894400'];
    public getElevationOptions() {
        return {
            theme: this.getTheme(this.themeColours[0]),
            animations: {
                enabled: false,
            },
            chart: {
                id: 'elevation-profile',
                type: 'area',
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true,
                    },
                    autoSelected: 'zoom', // accepts -> zoom, pan, selection
                },
                width: '100%',
            },
            stroke: this.getStroke(this.themeColours),
            markers: { 
                colors: this.themeColours,
                size: 0,
             },
            fill: {
                type: 'gradient',
                gradient: {
                    type: 'vertical',
                    shadeIntensity: 0.5,
                    opacityFrom: 0.7,
                    opacityTo: 0.4,
                },
            },
            xaxis: {
                type: 'area',
                labels: {
                    show: false,
                    hideOverlappingLabels: true,
                    formatter: (v) => `${(v / 1000.0).toFixed(1)}km`,
                },
            },
            tooltip: {
                y: {
                    formatter: (v) => `${v.toFixed(0)}m`,
                },
            },
            dataLabels: {
                enabled: false,
            }
        };
    }

    private getTheme(color: string) {
        return {
            monochrome: {
                enabled: true,
                color,
                shadeTo: 'light',
                shadeIntensity: 0.65,
            },
        };
    }

    private getStroke(colors: string[]) {
        return {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            colors,
            width: 1,
            dashArray: 0,
        };
    }
}

const chartOptions = new ChartOptions();

export default chartOptions;
